<template>
  <div class="page">
    <img class="illustration" src="@/assets/error.svg" />

    <p class="content">{{ $t('PROCESS_PURCHASE_AUTH_ERROR') }}</p>

    <div class="controls">
      <v-button tag="router-link" to="/link" type="primary">{{ $t('LINK_YOUR_DEVICE') }}</v-button>
      <v-button v-if="!isSafari" tag="a" :href="safariUrl">{{ $t('OPEN_IN_SAFARI') }}</v-button>
      <v-button tag="a" :href="cancelUrl" type="negative">{{ $t('RETURN_TO_APP') }}</v-button>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/Button.vue';
import isSafari from '../utils/isSafari';

export default {
  components: {
    VButton,
  },
  data() {
    return {
      isSafari: isSafari(),
    };
  },
  computed: {
    title() {
      return this.$t('ERROR');
    },
    appIdentifier() {
      return this.$route.query.appIdentifier;
    },
    purchaseTicket() {
      return this.$route.query.purchaseTicket;
    },
    cancelUrl() {
      return `appdb.${this.appIdentifier}://verifyPurchase=cancelled`;
    },
    originalUrl() {
      const url = new URL(window.location.origin);
      url.pathname = '/init-purchase';
      url.searchParams.set('purchaseTicket', this.purchaseTicket);
      url.searchParams.set('appIdentifier', this.appIdentifier);
      return url.toString();
    },
    safariUrl() {
      return this.originalUrl.replace(/https?:/, 'x-safari-https:');
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  text-align: center;
}

.controls {
  display: grid;
  grid-template-columns: max-content;
  justify-content: center;
  gap: 0.5rem;
}

.content {
  font-size: 14px;
  margin: 2rem 0;
}
</style>
